import { resultsSlice } from './reducer';

export const { savePlayer } = resultsSlice.actions;

export default {
  savePlayer,
};
